import React from 'react';
import PropTypes from 'prop-types';
import ReactAudioPlayer from 'react-audio-player';

class Player extends React.Component {
  render() {
    return (
      <div>
        { this.props.state.track && (
          <ReactAudioPlayer
            src={this.props.state.track.url}
            ref={(element) => { this.rap = element; }}
            controls={false}
            listenInterval={500}
            onLoadedMetadata={(e) => this.props.onLoadedMetadata(e)}
            onPlay={(e) => this.props.onPlay(e)}
            onListen={(e, d) => this.props.onListen(e,d)}
            onEnded={(e) => this.props.onEnded(e)}
          />
        ) }
      </div>
    );
  }
}

Player.propTypes = {
  state: PropTypes.object.isRequired,
  onLoadedMetadata: PropTypes.func,
  onPlay: PropTypes.func,
  onListen: PropTypes.func,
  onEnded: PropTypes.func
};

Player.defaultProps = {
  onLoadedMetadata: () => {},
  onPlay: () => {},
  onListen: () => {},
  onEnded: () => {}
};

export default Player;
